import "./Counters.scss";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Counter from "./counter";

const Counters = ({ data }) => {
  const countData = [
    {
      id: 0,
      num: data?.section_4_percentage_1,
      text: data?.section_4_title_1,
    },
    {
      id: 1,
      num: data?.section_4_percentage_2,
      text: data?.section_4_title_2,
    },
    {
      id: 2,
      num: data?.section_4_percentage_3,
      text: data?.section_4_title_3,
    },
    {
      id: 3,
      num: data?.section_4_percentage_4,
      text: data?.section_4_title_4,
    },
  ];

  return (
    <section className="counters_sec">
      <div className="content_wrap p_bottom">
        <h2 className="wow fadeInUp">{data?.percentage_title || "-"}</h2>
        <p className="wow fadeInUp" data-wow-delay="0.15s">
          {data?.percentage_description || "-"}
        </p>

        <div className="counter_grid">
          {countData?.map((data) => {
            return (
              <div className="counter_card" key={data?.id}>
                <div className="count">
                  <CircularProgressbar strokeWidth="4" value={data?.num} />
                  <Counter count={data?.num} />
                </div>
                <div className="text">
                  <p>{data?.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Counters;
